import countryJson from "flag-icons/country.json";
const INVALID_COUNTRY_DATA = "";
const UNKNOWN_COUNTRY_CODE = "xx";
export function getCountryData(countryCode) {
    var _a, _b;
    const validCountryData = countryJson.find((country) => country.code === countryCode);
    return {
        flagCode: (_a = validCountryData === null || validCountryData === void 0 ? void 0 : validCountryData.code) !== null && _a !== void 0 ? _a : INVALID_COUNTRY_DATA,
        flagName: (_b = validCountryData === null || validCountryData === void 0 ? void 0 : validCountryData.name) !== null && _b !== void 0 ? _b : INVALID_COUNTRY_DATA,
    };
}
export function getValidCountryData(countryCode) {
    let validCountryData = getCountryData(countryCode);
    if (validCountryData.flagCode === UNKNOWN_COUNTRY_CODE) {
        validCountryData = {
            flagCode: INVALID_COUNTRY_DATA,
            flagName: INVALID_COUNTRY_DATA,
        };
    }
    return validCountryData;
}
export function isBlockedCountry(countryCode) {
    return ["ru", UNKNOWN_COUNTRY_CODE, INVALID_COUNTRY_DATA].includes(countryCode);
}
